import { StoreType } from "@/interfaces/domain/StoreType";
import { api, image_path_store_types } from "@/services/api";

export async function getStoreTypesRequest() {
  const { data } = await api.get<StoreType[]>("/tipos-estabelecimentos");
  const withImage = data.map((item) => ({
    ...item,
    foto_tipo: `${image_path_store_types}/${item.foto_tipo}`,
  }));
  return withImage;
}

export async function getStoreTypeById(typeId: string) {
  const { data } = await api.get<StoreType>(`/tipos-estabelecimentos/${typeId}`);
  const withImage = {
    ...data,
    foto_tipo: `${image_path_store_types}/${data.foto_tipo}`,
  };
  return withImage;
}
